(function() {
  /*========================
    Mobile : afficher les liens
  ========================*/
  var elFooterLinks = $$('.main-footer-links-list-item__title');

  elFooterLinks.forEach(function(item) {
    item.onclick = showLinks;
  });

  function showLinks() {
    if (window.innerWidth <= 768) {
      var elLinks = this.closest('.main-footer-links-list__item');

      if (!elLinks.classList.contains('main-footer-links-list__item--active')) {
        elLinks.classList.add('main-footer-links-list__item--active');
      } else {
        elLinks.classList.remove('main-footer-links-list__item--active');
      }
    }
  }

  /*========================
    Vérifier la validité d'une adresse e-mail
  ========================*/
  function validateEmail(email) {
    var expr = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return expr.test(String(email).toLowerCase());
  }

  /*========================
    Enregistrer la demande de newsletter à la validation du formulaire
  ========================*/
  $('.main-footer-social-newsletter-content__form').onsubmit = function(e) {
    // Annuler le comportement par défaut
    e.preventDefault();

    // Les variables
    var email;
    var profile;
    var responseJSON;
    var elResponses;
    var tabMsg;

    // Les différents messages
    tabMsg = [];
    tabMsg['error'] = [];
    tabMsg['error']['email'] = "Votre adresse email n'est pas valide";
    tabMsg['error']['technical'] = 'Une erreur est survenue';
    tabMsg['success'] = 'Votre demande a bien été prise en compte';

    // Récupération de l'email et du profil
    email = $(
      '.main-footer-social-newsletter-content-form-container-input__email'
    ).value;
    profile = $(
      '.main-footer-social-newsletter-content-form-container-input__profile'
    ).value;

    // Supprimer les réponses déjà présentes dans le DOM
    elResponses = $$(
      '.main-footer-social-newsletter-content-form-container__response'
    );

    elResponses.forEach(function(el) {
      el.remove();
    });

    // Vérifier si l'email est valide
    if (!validateEmail(email)) {
      showNewsletterMessage('error', tabMsg['error']['email'], email);
    } else {
      //Envoi de la reqûete
      var xhttp = new XMLHttpRequest();
      xhttp.open('POST', ajaxNewslettersUrl, true);
      xhttp.setRequestHeader(
        'Content-Type',
        'application/x-www-form-urlencoded;'
      );

      xhttp.onload = function() {
        if (this.readyState == 4 && this.status >= 200 && this.status < 400) {
          responseJSON = JSON.parse(this.response);
          if (responseJSON.success) {
            showNewsletterMessage('success', tabMsg['success']);
          } else {
            showNewsletterMessage('error', tabMsg['error']['email'], email);
          }
        } else {
          showNewsletterMessage('error', tabMsg['error']['technical'], email);
        }
      };
      xhttp.send(
        'action=subscribeToNewsletter&email=' + email + '&abo_nl=oui&abo_commerce=oui&abo_invitation=oui&ope=Inscription Newsletters&local=Widget&categ=' + profile
        );
    }
  };

  function showNewsletterMessage(status, msg, email = null) {
    //Affichage du résultat (succès ou erreur)
    var elResponse = $(
      '.main-footer-social-newsletter-content-form__container'
    );
    if (status == 'error') {
      elResponse.innerHTML +=
        '<span class="main-footer-social-newsletter-content-form-container__response main-footer-social-newsletter-content-form-container__response--error">' +
        msg +
        '</span>';
      $(
        '.main-footer-social-newsletter-content-form-container-input__email'
      ).value = email;
    } else {
      elResponse.innerHTML +=
        '<span class="main-footer-social-newsletter-content-form-container__response main-footer-social-newsletter-content-form-container__response--success">' +
        msg +
        '</span>';
    }
  }


  /*========================
  Desktop/Mobile : accès à l'espace client perso/pro (affichage de la popin)
  ========================*/
  function showPersonalAccessPopin(e) {
    e.preventDefault();

    jQuery
      .ajax({
        url: ajaxurl,
        type: 'POST',
        data: {
          action: 'show_personal_access_popin'
        }
      })
      .done(function (response) {
        var popin = document.createElement('div');
        popin.innerHTML = response;
        popin.classList.add('popin-background');
        $('body').prepend(popin);

        $('.popin-close__icon, .popin-background').addEventListener(
          'click',
          hidePersonalAccessPopin,
          false
        );
      });
  }

  function hidePersonalAccessPopin(e) {
    if (
      e.target.classList.contains('popin-background') ||
      e.target.classList.contains('popin-close__icon') ||
      e.target.classList.contains('popin-close-icon__use')
    ) {
      var elNavMobile = $('.popin-background');
      if (elNavMobile != null) {
        elNavMobile.remove();
      }
    }
  }

  var personalAccessLink = $(
    '.main-footer-infos-item__link--customer-account'
  );

  if (personalAccessLink != null) {
    personalAccessLink.addEventListener(
      'click',
      showPersonalAccessPopin,
      false
    );
  }
})();
